import { encode } from "js-base64";
import { maketopQA, modifyTitle} from "@/api/ai.js";
export default {
    watch: {
        history: {
            handler(newVal) {
                this.transDrawData(newVal)
            },
            deep: true
        }
    },
    methods: {
        // 产生会话唯一值
        generateSessionHash() {
            return Math.random().toString(36).substring(2)
        },
        // 会话置顶
        maketopQA(item, type) {
            console.log('ietm----------------------', item, this.allHistory)
          maketopQA(item.RECID, type).then(res => {
            if (res.count == 200) {
              const ix = this.allHistory.findIndex(it => it.RECID == item.RECID)
              let curItem = this.allHistory.splice(ix, 1)
              this.allHistory.unshift(curItem[0])
              this.$message.success('会话置顶成功！')
            } else {
              this.$message.error('会话置顶失败！')
            }
          }).catch(err => {
            console.log( err)
            this.$message.error('会话置顶失败！')
          })
        },
        // 修改会话名称
        modifySession(item, type) {
          this.$prompt('请输入新的会话名称', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: '新会话的名称不能全部为空'
          }).then(({ value }) => {
            modifyTitle(encode(value), type, item.RECID).then(res => {
              if (res.count == 200) {
                const cutItem = this.allHistory.find(it => it.RECID == item.RECID)
                cutItem.TITLE = value
                this.$message.success(`你的新会话名称: ${value}`)  
              } else {
                this.$message.error('会话名称修改失败！')   
              }
            }).catch(err => {
              this.$message.error('会话名称修改失败！')   
            })
          }).catch(() => {
            this.$message.info('取消输入')      
          });
        },
        // 将后台历史记录转换成html数据
        transDrawData(data) {
            // this.history = data
            this.showHistory = []
            this.history.length > 0 &&  this.history.forEach((item, index) => {
                this.showHistory.push({
                    role: "user",
                    content: item.question,
                })
                // if ((index == data.length - 1 && item.content) || (index < data.length - 1)) {
                this.showHistory.push( {
                role: "assistant",
                question: item.question,
                content: item.content,
                createTime: item.createTime || '',
                showType: 'text',
                questionType: item.questionType || ''
                })
                // }
            })
        },
    }
}